export default [
    {
        path: '/emcadmin/plans',
        name: 'emcadmin-plans',
        component: () => import ('./views/PlanIndex'),
        meta: {
            title: 'Planos',
            icon: 'mdi-animation',
            breadcrumbs: [
                { text: 'Descrição da rota', disabled: true }
            ]
        }
    },
]
